import _classCallCheck from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { useShapeUniforms } from './gpgpu_math';
import { getChannels, getSourceCoords } from './packing_util';
import { getCoordsDataType } from './shader_compiler';
export var UnpackProgram = function UnpackProgram(outputShape) {
  _classCallCheck(this, UnpackProgram);
  this.variableNames = ['A'];
  this.packedInputs = true;
  this.packedOutput = false;
  this.outputShape = outputShape;
  this.enableShapeUniforms = useShapeUniforms(this.outputShape.length);
  var rank = outputShape.length;
  var channels = getChannels('rc', rank);
  var dtype = getCoordsDataType(rank);
  var sourceCoords = getSourceCoords(rank, channels);
  var innerDims = channels.slice(-2);
  var coords = rank <= 1 ? 'rc' : "vec2(".concat(innerDims.join(','), ")");
  this.userCode = "\n      void main() {\n        ".concat(dtype, " rc = getOutputCoords();\n        vec4 packedInput = getA(").concat(sourceCoords, ");\n\n        setOutput(getChannel(packedInput, ").concat(coords, "));\n      }\n    ");
};